import React from 'react';
import { QueryRenderer, graphql } from 'react-relay';
import { useParams } from 'react-router-dom';
import RelayEnv from '../RelayEnv';
import CallbackGraphiql from './CallbackGraphiql';

import QueryError from './QueryError';

export default function ChannelCallbackGraphiQLContainer() {
  let { channel_id } = useParams();

  return (
    <QueryRenderer
      query={graphql`
        query ChannelCallbackGraphiqlQuery($channel_id: ID!) {
          viewer {
            id
          }
          node(id: $channel_id) {
            id
            ... on OwnedChannel {
              id
              callbackQuery
            }
          }
        }
      `}
      environment={RelayEnv}
      variables={{ channel_id }}
      render={({ props, retry, error }) => {
        if (error) {
          return <QueryError retry={retry} error={error} />;
        } else if (props) {
          return (
            <CallbackGraphiql
              callbackQuery={props.node.callbackQuery}
              channelId={channel_id}
              {...props}
            />
          );
        } else {
          return null;
        }
      }}
    />
  );
}
